import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import router from '@/router/index.js'
import store from '@/store/store'
import '@/scss/main.scss'

import '@/scripts/filters/all.filter'
import '@/scripts/components/all'

import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import stockInit from 'highcharts/modules/stock'
import mapInit from 'highcharts/modules/map'
import VueShepherd from 'vue-shepherd'
import Clipboard from 'v-clipboard'

stockInit(Highcharts)
mapInit(Highcharts)
Vue.use(HighchartsVue)
Vue.use(VueShepherd)
Vue.use(Clipboard)

Vue.config.productionTip = false

let vue = new Vue({
    vuetify,
    store,
    router,
    render: (h) => h(App),
})

vue.$mount('#app')
